export * from './posicao-estoque.component';